import activityLog from './activityLogReducer';

export default {
  activityLog
};
